/**
 * Deterministic weekly rotation utilities.
 *
 * Given a list of candidate items, `pickWeeklyFeatured(items)` returns the same
 * item for every visitor within the same ISO week, and rotates to the next
 * candidate the moment the week rolls over. This keeps the Featured Flight
 * fresh without any admin intervention or client-side randomness.
 */

/**
 * Returns the ISO 8601 week number (1–53) for the given date.
 * Uses the "Thursday" trick so weeks roll on Monday.
 */
export function isoWeekNumber(date = new Date()) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number (Mon=1..Sun=7)
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return weekNo;
}

/** Human-friendly label like "Week 30" — used for the on-screen rotation badge. */
export function isoWeekLabel(date = new Date()) {
    return `Week ${isoWeekNumber(date)}`;
}

/**
 * Picks the current week's item from an ordered list of candidates.
 * Every candidate gets one week in rotation (round-robin by ISO week number).
 */
export function pickWeeklyFeatured(items, date = new Date()) {
    if (!Array.isArray(items) || items.length === 0) return null;
    const idx = isoWeekNumber(date) % items.length;
    return items[idx];
}
